import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Icon } from 'semantic-ui-react';
import FieldRow from '../FieldRow';
import { getActionOnFailLabel } from '../fieldsConfig';

const GroupedRuleList = ({
  rules, onIfNullChange, upsertNote, selectedProduct,
}) => {
  const groupedRules = useMemo(() => {
    if (!rules || !rules.length) return [];
    const groups = {};
    rules.forEach(rule => {
      const key = rule.actionOnFail || 'UNKNOWN';
      if (!groups[key]) groups[key] = [];
      groups[key].push(rule);
    });
    return Object.entries(groups);
  }, [rules]);

  const [activeIndices, setActiveIndices] = useState([]);

  // Initialize all accordion panels as open when groups change
  useEffect(() => {
    setActiveIndices(groupedRules.map((_, i) => i));
  }, [groupedRules]);

  const handleAccordionClick = (e, { index }) => {
    setActiveIndices(prev => (prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]));
  };

  return (
    <Accordion fluid styled data-testid='rules-accordion'>
      {groupedRules.map(([actionOnFail, groupRules], index) => (
        <React.Fragment key={actionOnFail}>
          <Accordion.Title
            active={activeIndices.includes(index)}
            index={index}
            onClick={handleAccordionClick}
            data-testid={`accordion-title-${actionOnFail}`}
          >
            <Icon name='dropdown' />
            {getActionOnFailLabel(actionOnFail)}{' '}
            <span className='accordion-rule-count' data-testid={`accordion-rule-count-${actionOnFail}`}>{groupRules.length}</span>
          </Accordion.Title>
          <Accordion.Content active={activeIndices.includes(index)}>
            {groupRules.map(rule => (
              <FieldRow
                key={rule.id}
                rule={rule}
                onIfNullChange={onIfNullChange}
                upsertNote={upsertNote}
                selectedProduct={selectedProduct}
              />
            ))}
          </Accordion.Content>
        </React.Fragment>
      ))}
    </Accordion>
  );
};

GroupedRuleList.propTypes = {
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      actionOnFail: PropTypes.string,
    })
  ).isRequired,
  onIfNullChange: PropTypes.func.isRequired,
  upsertNote: PropTypes.func.isRequired,
  selectedProduct: PropTypes.string.isRequired,
};

export default GroupedRuleList;
